module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/marquee-1-71f5c77a2418b48c9557ebb84f82e594.png";